import { lazy } from "react";
// Pre-Visit Planning Module (Módulo D — BillingV2)
// Huddle sheet por cita: HCCs sospechosos, care gaps, meds y labs antes de la visita.

// El guard resuelve el acceso restringido (allowlist de empleados) y, si pasa,
// renderiza la página. Lazy: nada del módulo viaja en el bundle inicial.
const PrevisitGuardedRoute = lazy(() => import("./components/PrevisitGuardedRoute"));

// Export routes for AppRouter
export const previsitPlanningRoutes = [
  {
    path: "/previsit-planning",
    element: <PrevisitGuardedRoute />,
  },
];

// Export components for external use

// Export utilities
export * from "./common/constants";
